import dayjs from 'dayjs'

import CloseOutlinedIcon from '@ant-design/icons/CloseOutlined'
import FileOutlinedIcon from '@ant-design/icons/FileOutlined'

import Chip from '@mui/material/Chip'
import Collapse from '@mui/material/Collapse'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import IconButton from '@components/_mui/IconButton'
import Typography from '@components/_mui/Typography'

export const styles = {
  positive: (isPositive, isHIVPositive) => ({
    cursor: 'pointer',
    borderLeft: (theme) =>
      `${theme.spacing(0.5)} solid ${isPositive ? (isHIVPositive ? theme.palette.brand.purple : theme.palette.error.main) : 'transparent'}`,
  }),
}

export function SelectedUnmatchedLab({ lab, open, onClose }) {
  if (!lab) return

  const title = `${lab.patientFirstName} ${lab.patientLastName}, ${lab.patientDob ? dayjs(lab.patientDob).format('L') : 'DOB: N/A'}`

  return (
    <Collapse in={open} unmountOnExit>
      <Paper sx={{ p: 2, mb: 2, width: { xs: '100%', md: 600 } }}>
        <Stack>
          <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
            <Stack>
              <Typography copy={title} sx={{ fontWeight: 'bold' }}>
                {title}
              </Typography>
              {lab.createdAt && (
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {dayjs(lab.createdAt).format('MMM D, hh:mm A')}
                </Typography>
              )}
            </Stack>
            <IconButton onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Stack>
          {lab.resultFiles?.length > 0 && (
            <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
              {lab.resultFiles.map((file, i) => (
                <Chip
                  key={i}
                  label={file.fileName}
                  variant="outlined"
                  icon={<FileOutlinedIcon />}
                  clickable
                  onClick={(e) => e.stopPropagation()}
                  component="a"
                  href={file.url}
                  target="_blank"
                />
              ))}
            </Stack>
          )}
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Typography>Please select the lab you want to relate it to</Typography>
      </Paper>
    </Collapse>
  )
}
